import { webhookTypes } from './webhook.types';

const INITIAL_STATE = {
  webhooks: [],
  loading: false,
};

const webhooksReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case webhookTypes.LOADING_WEBHOOKS:
      return { ...state, loading: true };
    case webhookTypes.SET_WEBHOOKS:
      return { ...state, webhooks: action.payload, loading: false };
    case webhookTypes.SET_NEW_WEBHOOK:
      return { ...state, webhooks: [...state.webhooks, action.payload] };
    case webhookTypes.EDIT_WEBHOOK_START:
      return state;
    case webhookTypes.SET_ON_EDIT_WEBHOOK:
      const newWebhooksList = state.webhooks.map((item) => {
        if (item.webhookId === action.payload.webhookId) {
          return { ...item, ...action.payload };
        }
        return item;
      });
      return { ...state, webhooks: newWebhooksList };
    case webhookTypes.SET_WEBHOOK_STATUS:
      const newWebhookList = state.webhooks.map((item) => {
        if (item.webhookId === action.payload.webhookId) {
          return {
            ...item,
            enabled: action.payload.enabled,
            statusLoading: false,
          };
        }
        return item;
      });
      return { ...state, webhooks: newWebhookList };
    case webhookTypes.SET_WEBHOOK_STATUS_LOADING: {
      const newWebhookList = state.webhooks.map((item) => {
        if (item.webhookId === action.payload) {
          return { ...item, statusLoading: true };
        }
        return item;
      });

      return { ...state, webhooks: newWebhookList };
    }

    default:
      return state;
  }
};

export default webhooksReducer;
